import { render, staticRenderFns } from "./PreviousOrders.vue?vue&type=template&id=e328273a&scoped=true&"
import script from "./PreviousOrders.vue?vue&type=script&lang=js&"
export * from "./PreviousOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e328273a",
  null
  
)

export default component.exports